module.exports = __webpack_public_path__ + "static/media/235-tokelau.b60df411.svg";